import React, { Component, Fragment } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import Selectsearch from "react-select";
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import DatePicker from "react-datepicker";

import {
	FormGroup,
	Label,
	Input,
} from 'reactstrap';

import {  
    allStudents,
    fetchPlayerIntervention,
} from 'Actions';

import FirstItem from './component/firstdata';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';


class playerintervention extends Component {
   
    constructor(props) {
       
        super(props);
        let startDate = new Date();
        let befrstart=new Date(startDate.setMonth(startDate.getMonth() - 2));
            this.state = {
                
                student:'',
                startdate:befrstart,
                enddate:new Date(),
                viewdiv1:true,
                viewdiv2:false,
                longgame:[],               
                
            };  

        this.onBackSection = this.onBackSection.bind(this);  
    }

    UNSAFE_componentWillMount() {
		this.props.allStudents(); 
	}    

    selstudent(evt){
        var student=evt.value;
        var stdate=this.state.startdate;
        var eddate=this.state.enddate;

        this.setState({ 
            student: student,  
            viewdiv2:false,
        }); 

        this.props.fetchPlayerIntervention(student, stdate, eddate).then((data) => {   
            var resdata=data.data;            
            this.setState({ 
                viewdiv2:true,  
              });

        });
    }

    onBackSection(){
        this.setState({ 
            student: '',
            viewdiv1:false,
        }); 
    }
    
    selectstart = (date) => {  
        this.setState({ startdate:date });           
    }

    selectend = (date) => {  
        this.setState({ enddate:date });           
    }

    handleSubmit(evt){
        evt.preventDefault();   
        var student=this.state.student;
        var stdate=this.state.startdate;
        var eddate=this.state.enddate;  
        
        this.setState({ 
           
            viewdiv2:false,
        });
        
        this.props.fetchPlayerIntervention(student, stdate, eddate).then((data) => {   
            var resdata=data.data;            
            this.setState({ 
                viewdiv2:true,  
              });

        });
    }   
    
    render() {
        const { match, studentlists, playerinterventionlist, loading } = this.props;       
        const allstudent=studentlists.map((stdval) => {  
            return {
               label: stdval.student,  
               value: stdval.uudID
            }
        });

        

       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>Player Intervention Log | {AppConfig.appTitle}</title>
                <meta name="description" content="Golf Team" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.playerintervention" />} match={match} />

                <div className="row">
                        <div className="col-sm-12 col-md-4">
                            <RctCollapsibleCard> 
                                <div className="row">                                        
                                    <div className="col-sm-12 col-md-12"> 
                                        <FormGroup>
                                            <Label for="Select">Student *</Label>
                                            <Selectsearch id="student" name="student" placeholder="Select Student *" options={allstudent} value={allstudent.find(obj => obj.value === this.state.student)} onChange={evt => this.selstudent(evt)} required/>
                                        </FormGroup>
                                    </div>                                     
                                </div>
                            </RctCollapsibleCard>  
                        </div>
                        {this.state.viewdiv1 &&                             
                            <div className="col-sm-12 col-md-6">
                                <RctCollapsibleCard>                              
                                    <form autoComplete="off" id="addform" onSubmit={(e)=>this.handleSubmit(e)}>              
                                        <div className="row">                                                    
                                            <div className="col-md-5">
                                                <FormGroup >
                                                    <DatePicker className="form-control" id="startdate" placeholderText="Start Date"  name="startdate" required autoComplete="off" 
                                                            selected={this.state.startdate}
                                                            onChange={this.selectstart}
                                                            dateFormat='yyyy-MM-dd'
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown 
                                                        /> 
                                                </FormGroup>                                          
                                            </div>
                                            <div className="col-md-5">
                                                <FormGroup >
                                                    <DatePicker className="form-control" id="enddate" placeholderText="End Date"  name="enddate" required autoComplete="off" 
                                                            selected={this.state.enddate}
                                                            onChange={this.selectend}
                                                            dateFormat='yyyy-MM-dd'
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                        /> 
                                                </FormGroup>                                          
                                            </div>
                                            <div className="form-group">                       
                                                <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Filter"/>                                            
                                            </div>              
                                        </div>
                                    </form>  
                                </RctCollapsibleCard>                                                    
                            </div>
                        }
                </div>

                {this.state.viewdiv2 &&
                   
                   <FirstItem data={this.state} />

                }
            
          </div>
       )
    }
 }
 
 const mapStateToProps = ({ mostlyused, playerintervention  }) => {
    const { studentlists, loading } = mostlyused;
    const { playerinterventionlist } = playerintervention;
	return { studentlists, playerinterventionlist, loading };
}

export default connect(mapStateToProps, {
    allStudents,
    fetchPlayerIntervention,
})(playerintervention); 